<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">余計な〝デューデリジェンス〟の罠
</h1>	

                <span class="meta"> Posted in May 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/eternal-due-diligence.jpg" alt="">
                </figure>
                
<p>直近6ヶ月の間に、私たちは特に注目していた、あるスタートアップへの投資を断念せざるを得なくなり、2つ目の件についても同じ理由から同様の事態をかろうじて回避した。</p>
<p>その理由は、投資プロセスにおけるデューデリジェンスの段階にあった。</p>
<p>デューデリジェンスという言葉は、創業者にとっては誤解を招きやすい。VC の中でも、この用語の使い方はさまざまだ。ある VC は、デューデリジェンスという言葉を非常に広義で使っていて、デューデリジェンスの範囲は、ほぼ全取引プロセスに及んでいる。デューデリジェンスは、スタートアップの最初のピッチミーティングの直後に始まり、市場分析、戦略的レビュー、ビジネスモデル評価、評価ベンチマーク、完全な財務・法務監査、リファレンスコール、顧客見込み客やパートナーとのインタビューなど、VC のスタートアップに対する評価全体を含むことがある。</p>
<p>これに対して、私は旧態依然とした人間だ。デューデリジェンスとは、シリコンバレー流に言えば、「信じ込まされていることが本当に正しいかどうかを検証する」という、より狭義のものである。具体的には、デューデリジェンスとは、顧客とリファレンスへの問い合わせと、必要に応じて詳細な監査（財務、法務、技術）を行うこと、というのが私の狭義での解釈だ。それ以前のことは、VC としての私の仕事の一部に過ぎない。</p>
<p>しかし、私は意味論について文句を言うためにこれを書いているのではない。私の狭義でのデューデリジェンスと、一部の投資家の広義でのデューデリジェンスの中間であれば、どちらの定義でも問題ない。</p>
<p>私の目的は、むしろ、創業者が不注意にせよ誤解を受けないように、この概念に透明性を持たせることだ。VC のデューデリジェンス手続きの性質と期間に関する不透明さは、起業家にとって不利益となる。貴重な資金調達の時間を無駄にし、他の VC ファンドからの投資を逃し、最悪の場合、取引先との関係を危うくする可能性がある。</p>
<p>ここで、デューデリジェンスという言葉の意味を明確にし、混乱を避けるために、デューデリジェンスという言葉を使うことは控えることにする。その代わりに、VC の投資プロセスにおける重要なマイルストーンである VC タームシートについて言及しよう。</p>
<p>VC タームシートは、投資の青写真であり、より永続的で法的拘束力のある文書の基礎を形成する法的拘束力のない文書である。VC がスタートアップに投資する際の具体的な条件、評価、権利などを定めるものだ。</p>
<p>タームシートは、VC 側の投資に対する真の意図を示すものであるため、スタートアップの創業者にとって重要だ。しかし、タームシートは、予定されている取引に一定の条件を課す、拘束力のない文書だ。例えば、Shizen Capital のタームシートは、私の狭義のデューデリジェンス（リファレンスコール）の満足な結果、およびファンドの投資委員会の承認を条件としている。</p>
<p>私は、VC のベストプラクティスは、タームシートが合意された後にのみ、VC がスタートアップの顧客／見込み客／パートナーとリファレンスチェックを行うことを許可されるべきだと思う。創業者は、このプラクティスに例外を設けることに同意するかもしれないが、これは創業者の特権であるべきで、創業者はこれを標準とするプレッシャーを感じるべきではないと私は考える。</p>
<p>私は、日本の多くのスタートアップが資金調達の際に、潜在的な投資家からのリファレンスコール依頼で顧客に過度の負担をかけるという罠にはまるのを目撃してきた。このような状況が発生した経緯は、今となっては完全に理解できるし、日本の VC の仲間の行動を非難するものではない。VC は、自分の意思決定プロセスを安心させるために、できるだけ多くの情報を集めようとしているだけなのだ。特に階層的な VC ファンドの構造では、スタートアップを評価するアナリストやジュニアアソシエイトは、確証のない投資案件を提示することで、キャリアを制限するような動きをすることを恐れている。</p>
<p>しかし、アーリーステージのベンチャー企業では、すべての不確実性を排除することは不可能であるという難点がある。</p>
<p>その結果、創業者に大きなダメージを与えかねない、本質的なズレが生じてしまう。数週間で終わるはずの投資プロセスが数ヶ月に延びることもある。さらに悪いことに、スタートアップの顧客に疑念を抱かせることになり、頻繁にリファレンスコールが来ると、次のように思い始める。</p>
<p>    このスタートアップは資金調達に苦労しているのだろうか？</p>
<p>    このスタートアップは財務的に安定しているのだろうか、それとも自分のビジネスを他のベンダーに乗り換えることを検討すべきなのだろうか。</p>
<p>    このスタートアップの顧客であることは、常に面倒で時間のかかることなのだろうか？</p>
<p>見込みのある投資家が顧客への問い合わせを要求し、その後、投資しないことを決めた場合、そのスタートアップの創業者は、顧客に対する好意を少し浪費してしまったことになる。これを複数の VC に掛け合わせると、そのスタートアップの取引先との関係に負担となる。</p>
<p>創業者は、リファレンスコールを要求してきた VC 候補に、リファレンスコールを許可する義務を感じるべきではない。</p>
<p>タームシートが締結されるまでリファレンスコールを延期することで、純粋に投資に興味を持つ VC と、単に情報収集や漁夫の利を狙う VC を分けることができる。</p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

